import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-dispute',
  templateUrl: './create-dispute.component.html',
  styleUrls: ['./create-dispute.component.css']
})
export class CreateDisputeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
